import Base from 'app/collections/base';
import { fulfillmentUrl } from 'utils/wrappers';
import FulfillmentWarehouse from 'app/models/fulfillment_warehouse';

export default Base.extend({
  model: FulfillmentWarehouse,
  key: 'warehouses',
  url: fulfillmentUrl('warehouses'),

  initialize(models, { apiModeSelection }) {
    this.apiModeSelection = apiModeSelection;
  },

  paramsForFetch() {
    return {
      ...this.apiModeSelection.getParams(),
    };
  },

  parse(response) {
    return response[this.key];
  },
});



// WEBPACK FOOTER //
// ./app/collections/fulfillment_warehouses.js